import React from "react";
import {
  Container,
  Typography,
  Box,
  Paper,
  Grid,
  useTheme,
  useMediaQuery,
  LinearProgress,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const TestCompleted = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const userData = useSelector((state) => state.user.userData);
  const userPercentage = userData?.percentage || 0;
  const correct_count = userData?.correct_count || 0;
  const incorrect_count = userData?.incorrect_count || 0;

  const getScholarshipPercentage = (percentage) => {
    percentage = Number(percentage);
    percentage = percentage < 0 ? 0 : percentage;

    if (percentage >= 90) return 100;
    if (percentage >= 80) return 90;
    if (percentage >= 60) return 80;
    if (percentage >= 40) return 60;
    if (percentage >= 20) return 50;
    if (percentage >= 10) return 35;
    return 25;
  };

  const scholarshipPercentage = getScholarshipPercentage(userPercentage);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#f5f5f5",
        py: 4,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
  <Container maxWidth="md">
  <Paper
    elevation={3}
    sx={{
      p: { xs: 2, sm: 4 },
      borderRadius: 2,
      textAlign: "center",
      bgcolor: "white",
      boxShadow: "40 40px 20px rgba(10, 10, 10, 0.08)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <Grid container spacing={3} sx={{ mb: 4 }}>
      {/* First Box: Congratulations & Scholarship */}
      <Grid item xs={12} sm={6} md={6}>
      <Box
  sx={{
    width: {
      xs: "100%",  // 100% width on small screens (mobile)
      md: "250%",  // 250% width on medium and larger screens (desktop)
    },
    p: { xs: 2, sm: 3 }, // Adjust padding based on screen size
    borderRadius: 3,
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
    backgroundColor: "#ffffff",
  }}
>
  {/* Content here */}

          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: "#26418F",
              mb: 1,
              fontSize: { xs: "1.75rem", sm: "2.125rem" },
              textAlign: "center",
            }}
          >
            Congratulations
          </Typography>
          <Box sx={{ textAlign: "center", mb: 2 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              🏆 You're eligible for a {scholarshipPercentage}% Scholarship
            </Typography>
          </Box>

          {/* SVG Circular Chart */}
          <Box sx={{ height: 160, width: 200, margin: "0 auto", position: "relative" }}>
            <svg width="160" height="160" viewBox="0 0 36 36" style={{ transform: "rotate(-90deg)" }}>
              <path
                fill="none"
                stroke="#eee"
                strokeWidth="3.8"
                d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <path
                fill="none"
                stroke="#00c853"
                strokeWidth="3.8"
                strokeDasharray={`${scholarshipPercentage}, 100`}
                d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <text x="18" y="18" textAnchor="middle" transform="rotate(90, 18, 18)">
                <tspan x="18" dy="-2" fontSize="6" fontWeight="bold" fill="#333">
                  {scholarshipPercentage}%
                </tspan>
                <tspan x="18" dy="5" fontSize="3" fontWeight="bold" fill="#000000">
                  Scholarship
                </tspan>
              </text>
            </svg>
          </Box>

          {/* Progress & Stats */}
          <Box sx={{ mt: 2, mb: 2 }}>
            <Typography variant="body2" sx={{ mt: 1, textAlign: "center" }}>
              Test Score {userPercentage}%
            </Typography>
            <LinearProgress
              variant="determinate"
              value={userPercentage}
              sx={{
                width: "100%", // Ensure it is responsive
                maxWidth: 200, // Max width for larger screens
                height: 10,
                borderRadius: 5,
                bgcolor: "#d7f7e4",
                mx: "auto", // Center horizontally
              }}
            />
          </Box>

          <Typography variant="body1" sx={{ mt: 2 }}>
            <span style={{ color: "#00c853", fontWeight: "bold" }}>Correct</span>:{" "}
            {correct_count} questions
            <br />
            <span style={{ color: "#f44336", fontWeight: "bold" }}>Incorrect</span>:{" "}
            {incorrect_count} questions
          </Typography>

          <Button
            variant="contained"
            onClick={() => navigate('/test')}
            sx={{
              width: "100%", // Full width for smaller screens
              maxWidth: 200, // Max width for larger screens
              borderRadius: 10,
              textTransform: "none",
              mt: 2,
              mb: 2,
              mx: "auto", // Center horizontally
              display: "block", // Required when not using fullWidth
            }}
          >
            Review My Answers
          </Button>
        </Box>
      </Grid>

      {/* Second Box: Address & Contact */}
      <Grid item xs={12} sm={6} md={6}>
        <Box
          sx={{
            width: "100%", // Full width on smaller screens
            p: { xs: 2, sm: 3 }, // Adjust padding for responsiveness
            borderRadius: 3,
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
            backgroundColor: "#ffffff",
            mt: 2,
          }}
        >
           <Typography
  variant="h6"
  sx={{
    fontWeight: 700,
    color: "#26418F",
    mb: 1,
    fontSize: { xs: "1.75rem", sm: "2.125rem" },
    textAlign: "center",
    // textDecoration: "underline",  // This will add an underline
  }}
>
  Lakshya Institute Jalandhar
</Typography>

          <Typography variant="body1" sx={{ textAlign: "center" }}>
            SCS-8, Crystal Plaza, Chotti Baradari-2, Garha Road, Jalandhar, 144022 Punjab, India
          </Typography>
          <Typography variant="body1" sx={{ textAlign: "center" }}>
            or Call us at{" "}
            <a
              href="tel:+918503887038"
              style={{
                color: "#2196F3",
                textDecoration: "none",
                fontWeight: "bold",
              }}
            >
              +91 8503887038
            </a>{" "}
            for your Scholarship.
          </Typography>

          {/* Google Map */}
          <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
            <iframe
              title="Google Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3409.0397195494343!2d75.5948246!3d31.3026473!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391a5b38c0eabbaf%3A0x427cb02324b586f4!2sLakshya%20Jalandhar!5e0!3m2!1sen!2sin!4v1745408384191!5m2!1sen!2sin"
              width="80%" // Full width on smaller screens
              height="300"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </Box>

          <Box sx={{ mt: 4 }}>
            <Typography variant="body1" color="text.secondary">
              Thank you for participating in our scholarship assessment program. We appreciate your interest and wish you the best of luck!
            </Typography>
          </Box>
        </Box>
      </Grid>
    </Grid>
  </Paper>
</Container>


    </Box>
  );
};

export default TestCompleted;
